import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraParentCoachingSpotIllustration: FunctionComponent<Props> = ({ size = 96 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M32.225 0C27.8073 0 23.5212 0.757561 19.4855 2.25118C9.87754 5.81261 3.12272 13.7082 0.952482 23.9131C-0.481698 30.5668 -0.298315 36.7208 1.51654 42.7181C3.83349 50.3772 9.52089 56.8361 17.1205 60.4379C20.8932 62.23 25.2273 63.2532 30.0003 63.4783C30.6137 63.5061 31.2372 63.5213 31.8569 63.5213C35.6865 63.5213 39.5388 62.9965 43.3076 61.9619C43.5972 61.8898 43.8729 61.8152 44.1638 61.7292C47.5507 60.7377 50.5987 59.1694 53.2065 57.0738C56.0382 54.8113 58.369 51.9429 60.127 48.5535C60.4735 47.8857 60.8049 47.1825 61.1704 46.3415C63.1812 41.6722 64.1525 36.4451 63.9805 31.2194C63.8996 28.9087 63.5556 26.4527 62.9612 23.9131C61.9823 19.7927 60.3862 15.9176 58.345 12.7002C57.786 11.8364 57.2725 11.1105 56.7641 10.4579C53.0952 5.72534 47.3787 2.40421 40.2382 0.858738C37.6151 0.289618 34.9188 0.00126462 32.2262 0.00126462L32.225 0Z'
        fill={spotIllustration.background.fill}
      />
      <Path
        d='M33.4829 45.0819C34.6424 42.4042 34.5503 38.4651 32.8494 36.0232C31.6689 34.3279 29.3596 33.0121 27.3419 32.786C25.2349 32.5502 22.9926 32.7149 21.1479 33.8018C19.5265 34.7563 18.1577 36.1851 17.414 37.9488C16.9326 39.0888 16.7205 40.3447 16.786 41.5865C16.9172 44.0689 18.0572 46.6168 20.1377 47.9759C22.6507 49.6168 26.0442 50.3117 28.8866 49.261C30.6405 48.6122 32.6526 46.9977 33.4815 45.0833L33.4829 45.0819Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M35.6149 49.5457H49.7917C50.5416 49.5457 51.1494 48.9378 51.1494 48.188V28.2623C51.1494 27.5124 50.5416 26.9046 49.7917 26.9046L35.6149 26.9046C34.8651 26.9046 34.2572 27.5124 34.2572 28.2623V48.188C34.2572 48.9378 34.8651 49.5457 35.6149 49.5457Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M13.7251 25.3792L33.5573 12.994C34.3736 12.4847 35.455 12.8391 35.808 13.735C38.3378 20.1438 36.4275 27.3509 30.8963 30.8044C25.3651 34.2593 18.0493 32.8137 13.4028 27.7262C12.7539 27.016 12.9088 25.8885 13.7251 25.3792Z'
        fill={spotIllustration.primary.fill}
      />
    </Svg>
  )
}
